"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    n = (e = t) && "object" == typeof e && "default" in e ? e.default : e;

function l() {
  return (l = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var l in n) {
        Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
      }
    }

    return e;
  }).apply(this, arguments);
}

!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;

  if ("undefined" != typeof document) {
    var l = document.head || document.getElementsByTagName("head")[0],
        o = document.createElement("style");
    o.type = "text/css", "top" === n && l.firstChild ? l.insertBefore(o, l.firstChild) : l.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}(".styles-module_yt-lite__1-uDa {\n  background-color: #000;\n  position: relative;\n  display: block;\n  contain: content;\n  background-position: center center;\n  background-size: cover;\n  cursor: pointer;\n}\n\n/* gradient */\n.styles-module_yt-lite__1-uDa::before {\n   content: '';\n   display: block;\n   position: absolute;\n   top: 0;\n   background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==);\n   background-position: top;\n   background-repeat: repeat-x;\n   height: 60px;\n   padding-bottom: 50px;\n   width: 100%;\n   transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);\n}\n\n/* responsive iframe with a 16:9 aspect ratio\n  thanks https://css-tricks.com/responsive-iframes/\n*/\n.styles-module_yt-lite__1-uDa::after {\n  content: \"\";\n  display: block;\n  padding-bottom: calc(100% / (16 / 9));\n}\n.styles-module_yt-lite__1-uDa > iframe {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* play button */\n.styles-module_yt-lite__1-uDa > .styles-module_lty-playbtn__1pxDJ {\n  width: 70px;\n  height: 46px;\n  background-color: #212121;\n  z-index: 1;\n  opacity: 0.8;\n  border-radius: 14%; /* TODO: Consider replacing this with YT's actual svg. Eh. */\n  transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);\n}\n.styles-module_yt-lite__1-uDa:hover > .styles-module_lty-playbtn__1pxDJ {\n  background-color: #f00;\n  opacity: 1;\n}\n/* play button triangle */\n.styles-module_yt-lite__1-uDa > .styles-module_lty-playbtn__1pxDJ:before {\n  content: '';\n  border-style: solid;\n  border-width: 11px 0 11px 19px;\n  border-color: transparent transparent transparent #fff;\n}\n\n.styles-module_yt-lite__1-uDa > .styles-module_lty-playbtn__1pxDJ,\n.styles-module_yt-lite__1-uDa > .styles-module_lty-playbtn__1pxDJ:before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n}\n\n/* Post-click styles */\n.styles-module_yt-lite__1-uDa.styles-module_lyt-activated__3ROp0 {\n  cursor: unset;\n}\n.styles-module_yt-lite__1-uDa.styles-module_lyt-activated__3ROp0::before,\n.styles-module_yt-lite__1-uDa.styles-module_lyt-activated__3ROp0 > .styles-module_lty-playbtn__1pxDJ {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.styles-module_yt-lite-thumbnail__2WX0n {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  object-fit: cover;\n}\n"), exports.LiteYoutubeEmbed = function (e) {
  var o = e.id,
      a = e.params,
      i = void 0 === a ? {} : a,
      s = e.defaultPlay,
      r = void 0 !== s && s,
      c = e.adLinksPreconnect,
      u = void 0 === c || c,
      d = e.isPlaylist,
      p = void 0 !== d && d,
      y = e.noCookie,
      m = void 0 === y || y,
      _ = e.mute,
      b = e.isMobile,
      h = void 0 !== b && b,
      f = e.mobileResolution,
      g = void 0 === f ? "hqdefault" : f,
      v = e.desktopResolution,
      k = void 0 === v ? "maxresdefault" : v,
      A = e.lazyImage,
      E = void 0 !== A && A,
      w = void 0 === _ || _ || r ? "1" : "0",
      x = t.useMemo(function () {
    return function (e) {
      return Object.keys(e).map(function (t) {
        return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
      }).join("&");
    }(l({
      autoplay: "1",
      mute: w
    }, i));
  }, []),
      D = h ? "https://i.ytimg.com/vi/" + o + "/" + g + ".jpg" : "https://i.ytimg.com/vi/" + o + "/" + k + ".jpg",
      O = m ? "https://www.youtube-nocookie.com" : "https://www.youtube.com",
      R = p ? O + "/embed/videoseries?list=" + o : O + "/embed/" + o + "?" + x,
      C = t.useState(!1),
      j = C[0],
      J = C[1],
      F = t.useState(r),
      S = F[0],
      q = F[1],
      z = t.useState(D),
      B = z[0],
      I = z[1],
      T = t.useCallback(function () {
    j || J(!0);
  }, []),
      U = t.useCallback(function () {
    S || q(!0);
  }, []);
  return t.useEffect(function () {
    if (!(h && "hqdefault" === g || !h && "hqdefault" === k)) {
      var e = new Image();
      e.onload = function () {
        120 !== e.width && 0 !== e.width || I("https://i.ytimg.com/vi/" + o + "/hqdefault.jpg");
      }, e.src = B;
    }
  }, [o, B]), n.createElement(n.Fragment, null, n.createElement("link", {
    rel: "preload",
    href: B,
    as: "image"
  }), j && n.createElement(n.Fragment, null, n.createElement("link", {
    rel: "preconnect",
    href: O
  }), n.createElement("link", {
    rel: "preconnect",
    href: "https://www.google.com"
  })), j && u && n.createElement(n.Fragment, null, n.createElement("link", {
    rel: "preconnect",
    href: "https://static.doubleclick.net"
  }), n.createElement("link", {
    rel: "preconnect",
    href: "https://googleads.g.doubleclick.net"
  })), n.createElement("div", {
    onClick: U,
    onPointerOver: T,
    className: "styles-module_yt-lite__1-uDa " + (S && "styles-module_lyt-activated__3ROp0")
  }, n.createElement("img", {
    src: B,
    className: "styles-module_yt-lite-thumbnail__2WX0n",
    loading: E ? "lazy" : void 0
  }), n.createElement("div", {
    className: "styles-module_lty-playbtn__1pxDJ"
  }), S && n.createElement("iframe", {
    width: "560",
    height: "315",
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: !0,
    src: R
  })));
};